import React, { useState } from "react";
import { useIsMobile } from "@/hooks/hooks/use-mobile";
import type { AppointmentListFragment } from "../types";

interface TooltipState {
  appointment: AppointmentListFragment;
  position: { x: number; y: number };
  isVisible: boolean;
}

export function useAppointmentTooltip() {
  const [tooltip, setTooltip] = useState<TooltipState | null>(null);
  const isMobile = useIsMobile();

  const handleMouseEnter = (appointment: AppointmentListFragment, e: React.MouseEvent) => {
    // Skip showing tooltip on mobile devices
    if (isMobile) {
      return;
    }
    const rect = e.currentTarget.getBoundingClientRect();
    const tooltipWidth = 250;
    const tooltipHeight = 200;
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    // Always position tooltip at bottom of appointment
    let y = rect.bottom + 5;

    // Start with left edge of appointment
    let x = rect.left;

    // If tooltip would go off right edge, adjust position
    if (x + tooltipWidth > screenWidth) {
      x = screenWidth - tooltipWidth - 10;
    }

    // If tooltip would go off left edge, align to left edge
    if (x < 10) {
      x = 10;
    }

    // Only if bottom position goes off-screen, move above appointment
    if (y + tooltipHeight > screenHeight) {
      y = rect.top - tooltipHeight - 5;
    }

    setTooltip({
      appointment,
      position: { x, y },
      isVisible: true,
    });
  };

  const handleMouseLeave = () => {
    setTooltip(null);
  };

  return {
    tooltip,
    handleMouseEnter,
    handleMouseLeave,
  };
}
